angular.module('rjmNg.directives').directive "setFocus", [
  "$timeout"
  "utils"
  ($timeout, utils) ->
    restrict: "A"
    link: (scope, element, attr) ->
      scope.$watch attr.setFocus, (setFocus, old) ->
        if setFocus
          $timeout ->
            element[0].focus() # had to use the raw node element's function so tests would work
            utils.set(scope, attr.setFocus, false) # attr.setFocus might be an expression like "view.hasFocus"

]
